import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: 'Mr. Amit Sharma',
    quote: 'Peaceful and Refreshing Stay',
    text: 'Woodland Escape is the perfect place to unwind. The surroundings are full of greenery, and the villa was very clean and well maintained. The staff was polite and helpful throughout our stay.',
    image: '/images/resource/image-2.png'
  },
  {
    name: 'Miss. Priya Nair',
    quote: 'Great Food and Warm Hospitality',
    text: 'We really enjoyed the stay. The food was fresh and tasty — both veg and non-veg options were good. The team took great care of our family and made sure we had everything we needed.',
    image: '/images/resource/image-2.png'
  },
  // {
  //   name: 'Rohit Patil',
  //   quote: 'Perfect Weekend Getaway',
  //   text: 'Beautiful location surrounded by forest. The bonfire night and morning walk made the trip special. It’s a great place to relax and reconnect with nature. Highly recommend for small groups or families.',
  //   image: '/images/resource/image-2.png'
  // }
];

const TestimonialsSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <section className="testimonials-section light-bg mx-60 border-shape-top">
      <div className="auto-container">
        <div className="row">
          {/* Left Section */}
          <div className="col-lg-7">
            <div
              className="content-block"
              style={{
                backgroundImage: "url('/images/resource/image-11.jpg')"
              }}
            >
              <div className="title-box text-light">
                <div className="sub-title">Testimonials</div>
                <h2 className="sec-title">Guest Experiences</h2>
              </div>
              {/* <div className="link-btn">
                <Link to="/testimonials" className="theme-btn btn-style-one">
                  <span>read all reviews</span>
                </Link>
              </div> */}
              <div className="award" data-parallax='{"y": 20}'>
                <img src="/images/icons/icon-1.png" alt="Award Icon" />
                <h4>
                  loved by <br /> nature lovers
                </h4>
              </div>
            </div>
          </div>

          {/* Right Section - Carousel */}
          <div className="col-lg-5">
            <Slider {...settings} className="testimonial-slider">
              {testimonials.map((item, index) => (
                <div className="testimonial-block" key={index}>
                  <h3>
                    <span className="quote">“</span>
                    {item.quote}
                  </h3>
                  <div className="text">{item.text}</div>
                  <div className="author-info">
                    {/* <div className="author-thumb">
                      <img src={item.image} alt={item.name} />
                    </div> */}
                    <div className="name">{item.name}</div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
